import homeicon from '../../src/assets/home.png';
import Timeicon from '../../src/assets/clock.png';
import Calicon from '../../src/assets/calculator (1).png';
import Profileicon from '../../src/assets/user.png';
import Reporticon from '../../src/assets/document.png';
import Deviceicon from '../../src/assets/mobile-phone.png';
import fileicon from '../../src/assets/fileupload.png';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import SecurityIcon from '@mui/icons-material/Security';
import SupportIcon from '@mui/icons-material/Support';
import security from '../assets/security.png';
import TopicIcon from '@mui/icons-material/Topic';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import InsightsIcon from '@mui/icons-material/Insights';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
export const sidebarListItems = (token = null) => [
  { id: '1', label: 'Dashboard', icon: <img src={homeicon} style={{ width: '20px' }} alt="Dashboard" />, path: '/home' },
  { id: '2', label: 'Emp OnBoard', icon: <AddToQueueIcon />, path: '/onboarding' },
  { id: '3', label: 'Enrolled Employees', icon: <PersonPinIcon />, path: '/view-onboarding' },
 { id: '4', label: 'Safety Analytics', icon: <img src={security} style={{ width: '20px' }} alt="Safety Analytics" />, path: '/safety-analytics' },
  { id: '19', label: 'Job Analytics', icon: <QueryStatsIcon />, path: '/job-analytics' },
  { id: '5', label: 'Time Sheets', icon: <img src={Timeicon} style={{ width: '20px' }} alt="Timesheets" />, path: '/dashboard' },
  { id: '6', label: 'Recap', icon: <img src={Calicon} style={{ width: '20px' }} alt="Recap" />, path: '/recap' },
  { id: '7', label: 'Users', icon: <img src={Profileicon} style={{ width: '20px' }} alt="Users" />, path: '/users' },
  {
    id: '8',
    label: 'Reports',
    icon: <img src={Reporticon} style={{ width: '20px' }} alt="Reports" />,
    path: token ? `/report?allow=${encodeURIComponent(token)}` : '/report',
  },
  {
    id: '9',
    label: 'Docs',
    icon: <img src={fileicon} style={{ width: '20px' }} alt="Docs" />,
    path: '/docs',
  },
  {
    id: '10',
    label: 'Forms',
    icon: <img src={Reporticon} style={{ width: '20px' }} alt="Forms" />,
    path: token ? `/forms?allow=${encodeURIComponent(token)}` : '/forms',
  },
  { id: '17', label: 'Subcontractors', icon: <AssignmentIndIcon />, path: '/subcontractors' }, 
  {
    id: '11',
    label: 'Devices',
    icon: <img src={Deviceicon} style={{ width: '20px', transform: 'rotate(90deg)' }} alt="Devices" />,
    path: '/devices',
  },
  // { id: '12', label: 'Safety', icon: <SecurityIcon />, path: '/safety' },
  { id: '13', label: 'Support', icon: <SupportIcon />, path: '/support' },
   { id: '14', label: 'Admin', icon: <AdminPanelSettingsIcon />, path: '/register' },
    { id: '15', label: 'Logs', icon: <DriveFileMoveIcon />, path: '/logs' },
        { id: '16', label: 'Tools and resources', icon: <TopicIcon />, path: '/manual-dashboard' },
    { id: '18', label: 'Web OTP', icon: <SecurityIcon />, path: '/otp-logs' },
];
export const acessPrivilages = [
  { id: 'A1', label: 'App Access', type: 'app' },
  { id: 'A2', label: 'Forms Edit Access', type: 'app' },
  { id: 'A4', label: 'Forms Delete Access', type: 'app' },
];

export const notificationPrivilages = [
  { id: 'N2', label: 'Weekly Driver Log Notifications', type: 'notification' },
  { id: 'N3', label: 'Subcontractor Notifications', type: 'notification' },
];